import * as React from "react";
import useReactRouter from "use-react-router";
import { Link } from "react-router-dom";
import cx from "classnames";
// components
import RoundImage from "common/components/roundImage";
import UserFollowButton from "common/components/userFollowButton";
import { STATUS_OF_DELETED_USER } from "@vingle/wtf-sdk/constants/default";
import { VingleURL } from "@vingle/wtf-sdk/url";
import { useTrackTicket } from "@vingle/wtf-sdk/helpers/trackTicket";
import translateURLToAppURL from "@vingle/wtf-sdk/helpers/translateURLToAppURL";

// styles
const styles = require("./listItem.scss");

interface IProps {
  user: Vingle.User.IUser;
  isOwn: boolean;
  onFollowClick: (user: Vingle.User.IUser) => void;
  referralUrl?: string;
  className?: string;
}

function UserListItem(props: IProps) {
  const { user, isOwn, onFollowClick, referralUrl, className } = props;
  const isFollowing = Boolean(user.relation && user.relation.following);
  const isDeletedUser = user.status === STATUS_OF_DELETED_USER;
  const handleUserFollow = React.useCallback(() => {
    onFollowClick(user);
  }, [onFollowClick, user]);
  const { location } = useReactRouter();
  const { handleRead } = useTrackTicket({
    contentId: user.id,
    contentType: "user",
    referralUrl: referralUrl || translateURLToAppURL(location.pathname),
  });
  return (
    <div className={styles.userWrapper}>
      <Link
        to={new VingleURL.UserShow({ username: user.username }).toString()}
        className={cx(styles.leftWrapper, className)}
        onClick={handleRead}
      >
        <div className={styles.userListItem}>
          <div className={styles.userProfileImageWrapper}>
            <RoundImage
              imageSrc={user.profile_image_urls}
              width={64}
              height={64}
            />
          </div>
          <div className={styles.userInfoWrapper}>
            <div className={styles.username}>{user.username}</div>
            <div className={styles.interests}>
              {user.top_interests
                ? user.top_interests
                    .map((interest: Vingle.Interest.IInterest) => {
                      return interest.name.split(":")[0];
                    })
                    .join(" ･ ")
                : null}
            </div>
            <div className={styles.bio} title={user.bio || undefined}>
              {user.bio}
            </div>
          </div>
        </div>
      </Link>
      {!isOwn && (
        <div className={styles.rightWrapper}>
          {isDeletedUser ? null : (
            <UserFollowButton
              isFollowing={isFollowing}
              onFollow={handleUserFollow}
              onUnFollow={handleUserFollow}
              followUser={user}
              width={105}
              height={40}
              fontSize={14}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default React.memo(UserListItem);
